export default __webpack_public_path__ + "img/0b97e882a06e618349f745d1dd32a099.png";